import { useState, useEffect } from 'react';
import { Box, IconButton, useMediaQuery } from '@mui/material';
import logo from '../../Assets/images/logocopy.png';
import { useNavigate, useLocation } from 'react-router-dom';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import MenuDrawer from '../MenuDrawer/MenuDrawer';
/* import { ContactUs } from '../../container'; */

const navOptions = [
  'Home',
  'About Us',
  'Contact',
  'Celebrity Training',
  'Services',
  'Events'
];

const Navbar = (props) => {
  const { refs = {}, scrollToSection = () => {} } = props;

  const [selectedTab, setSelectedTab] = useState(0);

  const [openDrawer, setOpenDrawer] = useState(false);

  const navigate = useNavigate();

  const location = useLocation();

  const isMobile = useMediaQuery('(max-width:768px)');

  const { pathname = '' } = location;

  const { homeRef = null } = refs;

  useEffect(() => {
    if (pathname === '/') {
      if (selectedTab === 0) {
        handleScrollTo('home-section');
      } else if (selectedTab === 1) {
        handleScrollTo('about-us-section');
      } else if (selectedTab === 2) {
        handleScrollTo('contactus-section', -100);
      } else if (selectedTab === 3) {
        handleScrollTo('celebrity-training-section', -50);
      } else if (selectedTab === 4) {
        handleScrollTo('services-section');
      } else if (selectedTab === 5) {
        handleScrollTo('events-section');
      }
    }
  }, [pathname, selectedTab]);

  useEffect(() => {
    if (pathname.includes('/celebrities')) {
      setSelectedTab(3);
    } else if (pathname.includes('/services')) {
      setSelectedTab(4);
    }
  }, [pathname]);

  const toggleDrawer = () => {
    setOpenDrawer(!openDrawer);
  };

  /*  const handleScrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest' // Align to the top
      });
    }
  }; */

  const handleScrollTo = (id, adjustTopValue = -50) => {
    const element = document.getElementById(id);
    if (element) {
      const yOffset = adjustTopValue; // Adjust this value based on your header height
      const y = element.getBoundingClientRect().top + window.scrollY + yOffset;

      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }
  };

  const handleNavgation = (index) => {
    if (index === 0) {
      navigate('/');
      //handleScrollTo('home-section');
    } else if (index === 1) {
      navigate('/');
      //handleScrollTo('about-us-section');
    } else if (index === 2) {
      navigate('/');
      // handleScrollTo('contactus-section');
    } else if (index === 3) {
      navigate('/');
      //handleScrollTo('celebrity-training-section');
    } else if (index === 4) {
      navigate('/');
      //handleScrollTo('services-section');
    } else if (index === 5) {
      navigate('/');
      //handleScrollTo('events-section');
      window.location.href = 'https://events.beatxfit.com/';
    }

    if (index !== 5) {
      setSelectedTab(index);
      scrollToSection(homeRef);
    }
  };

  const handleMenuClick = (index) => {
    handleNavgation(index);
    setOpenDrawer(!openDrawer);
  };

  return (
    <div
      style={{
        height: '10%',
        width: '100%',
        background: 'linear-gradient(135deg, #000000, #434343)',
        display: 'flex',
        justifyContent: 'space-between',
        position: 'fixed',
        zIndex: 1000,
        padding: '5px 0',
        paddingLeft: '15px'
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer'
        }}
        onClick={() => {
          handleScrollTo('home-section');
        }}
      >
        <img width={'135px'} src={logo} alt="cross fit logo" />
      </div>
      <div
        style={{
          display: 'flex',
          fontSize: '16px',
          fontWeight: 'bold',
          alignItems: 'center',
          zIndex: '100',
          paddingRight: !isMobile ? '70px' : ''
        }}
      >
        <Box
          sx={{
            display: { xs: 'block', sm: 'block', md: 'none', lg: 'none' },
            marginRight: '15px' // Show only on mobile and small tabs
          }}
        >
          <IconButton
            style={{ color: 'white' }}
            onClick={() => {
              toggleDrawer();
            }}
          >
            <MenuOpenIcon />{' '}
          </IconButton>
          <MenuDrawer
            navOptions={navOptions}
            openDrawer={openDrawer}
            toggleDrawer={toggleDrawer}
            handleMenuClick={handleMenuClick}
            selectedTab={selectedTab}
          />
        </Box>
        {navOptions.map((option, index) => {
          return (
            <Box
              key={`nav-option-${index}`}
              sx={{
                marginRight: '20px',
                display: { xs: 'none', sm: 'none', md: 'block', lg: 'block' },
                /* display: 'block',
                '@media (max-width: 600px)': {
                  display: 'none' // Hide on mobile screens
                }, */
                color: selectedTab === index ? '#26BDBE' : '#9f9f9f',
                cursor: 'pointer',
                '&:hover': {
                  color: '#2a8a8b'
                }
              }}
              onClick={() => {
                handleNavgation(index);
              }}
            >
              {option}
            </Box>
          );
        })}
      </div>
    </div>
  );
};

export default Navbar;
